import { render, staticRenderFns } from "./BibLabelSelect.vue?vue&type=template&id=7bfd3230&"
import script from "./BibLabelSelect.vue?vue&type=script&lang=js&"
export * from "./BibLabelSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports